import React from 'react'
import { Typography } from '@mui/material'
import useGoBackShiftDate from 'hooks/useGoBackShiftDate'
import BackButton from 'redesign/components/atoms/Buttons/BackButton'
import Header from 'redesign/components/organisms/Header'
import type { TaskDetailsHeaderProps } from './types'

const TaskDetailsHeader: React.FC<TaskDetailsHeaderProps> = ({ title, endContent }) => {
  const { gotoBackLink } = useGoBackShiftDate()

  return (
    <Header
      startContent={<BackButton onGoBack={gotoBackLink} />}
      middleContent={<Typography variant="subtitle1">{title}</Typography>}
      endContent={endContent}
    />
  )
}

export default TaskDetailsHeader
